import { ShoppingCartItemStatus } from '../../../../models/shopping-cart';

export const getBannerMessage = (cartItemStatus: ShoppingCartItemStatus): string => {
    switch (cartItemStatus) {
        case ShoppingCartItemStatus.Removed:
            return 'app.notification.articleRemoved.cartItem';
        case ShoppingCartItemStatus.Changed:
            return 'app.notification.articleChanged.cartItem';
        case ShoppingCartItemStatus.PriceByRequest:
            return 'app.notification.priceByRequest.cartItem';
        default:
            return 'app.notification.articleChanged.cartItem';
    }
};
